export const applyParams = (object = {}, params = {}, { allowZeroKeys = [] } = {}) => {
	Object.entries(object).forEach(([key, value]) => {
		const shouldInclude = Boolean(value) || (value === 0 && allowZeroKeys.includes(key));

		if (shouldInclude) {
			params[key] = value;
		}
	});
};

export const verifyDealershipIdParam = (filters, params) => {
	if (filters?.keywords && filters.keywords.includes('dealership_id=')) {
		const queryParams = new URLSearchParams(filters.keywords);
		params.dealership_id = queryParams.get('dealership_id');
		delete params.keywords;
	}
};
